const Presentacion = () => {
    return (
        <div
            id="Presentacion"
            className="presentacion p-4 sm:p-6 md:p-8 bg-gray-900/30 rounded-lg shadow-md mb-16 md:mb-36 lg:max-w-full md:max-w-3xl mx-auto"
        >
            <h1 className="text-2xl sm:text-3xl font-bold text-center mb-4 sm:mb-6">
                Carta de presentación
            </h1>
            <div className="bg-gray-800 p-4 sm:p-6 rounded-lg">
                <h3 className="text-sm sm:text-base leading-relaxed mb-3 sm:mb-4">
                    ¡Hola! Soy Karolis
                </h3>
                <p className="text-sm sm:text-base leading-relaxed mb-3 sm:mb-4">
                    Desarrollador web full stack junior, con muchas ganas, ideas y pasión por lo que hago.
                </p>
                <p className="text-sm sm:text-base leading-relaxed mb-3 sm:mb-4">
                    Desde que empecé en el mundo del desarrollo web, no he parado de aprender, probar cosas nuevas y crecer. He trabajado tanto en el frontend como en el backend, creando webs dinámicas, tiendas online a medida y colaborando en equipos con metodologías ágiles.
                </p>
                <p className="text-sm sm:text-base leading-relaxed mb-3 sm:mb-4">
                    He tenido la suerte de trabajar en empresas como <strong>Tracasa Instrumental</strong> y <strong>Agradaweb Digital Services</strong>, donde además de programar, aprendí a entender bien lo que necesita el cliente y cómo aportar valor real a cada proyecto.
                </p>
                <p className="text-sm sm:text-base leading-relaxed mb-3 sm:mb-4">
                   Me manejo con tecnologías como <strong>HTML5</strong>, <strong>CSS3</strong>, <strong>JavaScript</strong>, <strong>React</strong>, <strong>C#</strong>, <strong>SQL</strong> y <strong>.NET</strong>, y utilizo herramientas como <strong>Figma</strong>, <strong>Azure DevOps</strong> y <strong>Prestashop</strong>. Me adapto rápido a distintos entornos y siempre estoy dispuesto a enfrentar nuevos retos tecnológicos.
                </p>
                <p className="text-sm sm:text-base leading-relaxed mb-3 sm:mb-4">
                    Más allá del código, soy una persona comprometida, con iniciativa, con ganas de seguir creciendo y que disfruta trabajando en equipo. Me gusta comunicarme con claridad, aportar ideas y centrarme en obtener buenos resultados, tanto para el cliente como para el equipo.
                </p>
                <p className="text-sm sm:text-base leading-relaxed mb-1 sm:mb-4">
                    Gracias por pasarte por mi web. Si crees que podríamos colaborar en algún proyecto, o simplemente quieres conocerme un poco más, no dudes en escribirme. ¡Estaré encantado de hablar contigo!
                </p>
            </div>
        </div>
    );
};

export default Presentacion;